import TinyStore from 'lib/tinyStore';
import { ICampaign } from 'types/campaign';
import { TMessage } from 'types/inbox';

type InboxModal = {
    conversationList?: ICampaign | null;
    patientMessageMap?: Record<string, any> | null;
    loadingAllUnreadAmount: boolean;
    allUnreadCount?: number;
    conversationMessageMap?: Record<string, TMessage[]>;
};

const Store = TinyStore.createStore<InboxModal>({
    nameSpace: 'box_practice_inbox_store',
    key: 'inboxStore',
    crossBundle: false,
    runTime: true,
    initValue: {
        loadingAllUnreadAmount: false,
        conversationMessageMap: {},
    },
});
export default Store;
